// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"4be539e6","124":"a3b33f74","179":"c1d86d59","200":"e1604ad2","272":"55e463a1","358":"583b8342","404":"6905fac7","409":"0d0d1394","631":"53c832dc","818":"8b8a6c83","895":"f496920a","918":"1752d931"}[chunkId] + ".chunk.js";
};